<template>
  <div class="signUp">
    <welcome-image/>
    <section class="signUp__right">
      <form class="signUp__form">
        <div class="signUp__line">
          <h2 class="signUp__title">Создать кибераккаунт</h2>
        </div>
        <div class="signUp__line">
          <label class="signUp__textLabel">Почта</label>
          <form-input v-model="signUpStore.userName" type="email"/>
        </div>

        <div class="signUp__line">
            <CheckBox
                v-model="signUpStore.acceptFirst"
            >
              Я соглашаюсь на <ConsentLink slug="consent-personal">обработку персональных данных</ConsentLink>

            </CheckBox>
            <CheckBox
                v-model="signUpStore.acceptSecond"
            >
              Я соглашаюсь на <ConsentLink slug="consent-info">получение рекламно-информационных сообщений</ConsentLink>

            </CheckBox>

        </div>
        <div class="signUp__line">
            <ActionButton
                style="width: 150px"
                icon-type="arrow"
                @button-click="nextStepHandler"
            >
              <template #caption>Ещё 1 шаг</template>
            </ActionButton>
        </div>
        <div class="signUp__line">
          <span class="signUp__noAccount">
             Есть аккаунт? &nbsp;
              <router-link class="signUp__link"  :to="{name: 'SignInView'}" >Войти</router-link>
          </span>
        </div>
      </form>
    </section>

  </div>
</template>

<script>
import CheckBox from "@/components/ui/CheckBox.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import FormInput from "@/components/ui/FormInput.vue";
import ConsentLink from "@/components/ui/ConsentLink.vue";
import WelcomeImage from "@/components/shared/WelcomeImage.vue";
import {useSignUpStore} from "@/store/signup";
import {useRouter} from "vue-router";
import {useToast} from "vue-toast-notification";

export default {
  name: "SignUpStep1View",
  components: {WelcomeImage, FormInput, ActionButton, CheckBox, ConsentLink},
  setup() {

    const signUpStore = useSignUpStore();
    const toast = useToast();
    const router = useRouter();

    function validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    }
    async function nextStepHandler() {
      if(!validateEmail(signUpStore.userName)) {
        toast.error('Неверный формат email');
        return;
      }
      if(!signUpStore.acceptFirst) {
        toast.error('Вы не указали, что согласны на обработку персональных данных');
        return;
      }
      await router.push({name: 'SignUpStep2View'});
    }

    return {
      signUpStore, nextStepHandler, validateEmail,
    }
  }
}
</script>


<style scoped lang="scss">

@use "./SignUpView.scss";

</style>
